import { render, staticRenderFns } from "./Vodomeri.vue?vue&type=template&id=aa1b12e8"
import script from "./Vodomeri.vue?vue&type=script&lang=js"
export * from "./Vodomeri.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports